import { ProposalService } from '../services/proposal.service.js';
import { APP_VERSION } from '../version.js';
import { locale } from '../services/LocaleService.js';

export async function UserDashboardPage() {
    const container = document.createElement('div');
    container.className = "flex flex-col min-h-screen bg-gray-50 dark:bg-zinc-950 pb-20";

    // 1. Header Area (Simple Back + Title)
    // We reuse the main header, but maybe we want a specific header for this page?
    // Let's make it look like a standard page content with some padding.
    // If the main header is visible, we add top padding.

    // Check global header visibility logic in Router...
    // Router usually keeps header visible unless explicitly hidden.
    // So we add padding-top equal to header height (h-14).

    // Header Wrapper
    const headerWrapper = document.createElement('div');
    headerWrapper.className = "pt-20 px-6 pb-6";
    headerWrapper.innerHTML = `
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-1 flex items-center gap-2">
            <span class="material-symbols-outlined text-yellow-500">lightbulb</span>
            성좌의 지혜
        </h1>
        <p class="text-sm text-gray-500 dark:text-gray-400">성좌님의 빛나는 지혜가 우주를 확장시킵니다.</p>
    `;
    container.appendChild(headerWrapper);

    // 2. Tabs Navigation (Future proofing)
    const tabsContainer = document.createElement('div');
    tabsContainer.className = "px-6 border-b border-gray-200 dark:border-zinc-800 flex gap-6 mb-6 overflow-x-auto no-scrollbar";

    const tabs = [
        { id: 'proposals', label: '제안하기', active: true },
        // { id: 'overview', label: '내 활동', active: false }, // Future
    ];

    tabs.forEach(tab => {
        const btn = document.createElement('button');
        btn.className = `pb-3 text-sm font-medium transition-colors relative whitespace-nowrap ${tab.active
            ? 'text-violet-600 dark:text-violet-400'
            : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
            }`;
        btn.innerText = tab.label;

        if (tab.active) {
            const line = document.createElement('div');
            line.className = "absolute bottom-0 left-0 right-0 h-0.5 bg-violet-600 dark:bg-violet-400 rounded-t-full";
            btn.appendChild(line);
        }

        tabsContainer.appendChild(btn);
    });
    container.appendChild(tabsContainer);

    // 3. Content Area
    const contentArea = document.createElement('div');
    contentArea.className = "px-6 flex-1 max-w-3xl";
    container.appendChild(contentArea);

    // Render Proposal Tab Content
    renderProposalTab(contentArea);

    return container;
}

function renderProposalTab(container) {
    container.innerHTML = '';

    const card = document.createElement('div');
    card.className = "bg-white dark:bg-zinc-900 rounded-2xl p-6 shadow-sm border border-gray-100 dark:border-zinc-800";

    card.innerHTML = `
        <div class="mb-6">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">어떤 아이디어가 있으신가요?</label>
            <input type="text" id="proposal-title" 
                class="w-full px-4 py-3 bg-gray-50 dark:bg-zinc-800 border border-gray-200 dark:border-zinc-700 rounded-xl text-gray-900 dark:text-white focus:ring-2 focus:ring-violet-500 focus:border-transparent outline-none transition-all placeholder-gray-400"
                placeholder="${locale.t('placeholder.title_required')}"
            >
        </div>
        
        <div class="mb-6">
            <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">상세 내용</label>
            <textarea id="proposal-content" rows="6"
                class="w-full px-4 py-3 bg-gray-50 dark:bg-zinc-800 border border-gray-200 dark:border-zinc-700 rounded-xl text-gray-900 dark:text-white focus:ring-2 focus:ring-violet-500 focus:border-transparent outline-none transition-all placeholder-gray-400 resize-none"
                placeholder="${locale.t('placeholder.content_required')}"
            ></textarea>
        </div>

        <div class="flex justify-end">
            <button id="btn-submit-proposal" class="flex items-center gap-2 px-6 py-3 bg-violet-600 hover:bg-violet-700 text-white font-bold rounded-xl transition-all shadow-lg shadow-violet-500/30 disabled:opacity-50 disabled:cursor-not-allowed">
                <span class="material-symbols-outlined text-sm">send</span>
                지혜 전달하기
            </button>
        </div>
    `;

    container.appendChild(card);

    // Logic
    const titleInput = card.querySelector('#proposal-title');
    const contentInput = card.querySelector('#proposal-content');
    const submitBtn = card.querySelector('#btn-submit-proposal');

    submitBtn.onclick = async () => {
        const title = titleInput.value.trim();
        const content = contentInput.value.trim();

        if (!title || !content) {
            window.Modal.alert(locale.t('placeholder.title_required'));
            return;
        }

        submitBtn.disabled = true;
        submitBtn.innerHTML = `<div class="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></div> 전송 중...`;

        try {
            await ProposalService.submitProposal({
                title,
                content,
                version: APP_VERSION
            });

            window.Modal.toast("성좌님의 지혜가 우주에 기록되었습니다.");

            // Reset
            titleInput.value = '';
            contentInput.value = '';

        } catch (error) {
            console.error(error);
            window.Modal.alert(error.message || "제안 전송에 실패했습니다.");
        } finally {
            submitBtn.disabled = false;
            submitBtn.innerHTML = `<span class="material-symbols-outlined text-sm">send</span> 지혜 전달하기`;
        }
    };
}
